// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__LFeMQ","destructive":"style_destructive__41JwV","disabled":"style_disabled__2BObg","primary":"style_primary__1jjnL"};